import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronUp, ExternalLink, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import TechindoLogo from "./TechindoLogo";
import { CONTACT_INFO, SITE_META } from "@/constants";

const TEK_PORTAL_URL = "https://tek.techindoglobal.cloud/tenant/logout";

const TEK_PORTALS = [
  { label: "TEK EX", description: "Tenant admin portal", href: TEK_PORTAL_URL },
  { label: "TEK API", description: "Link coming soon" },
  { label: "TEK UC", description: "Link coming soon" },
  { label: "TEK Bot", description: "Link coming soon" },
  { label: "TEK CX", description: "Link coming soon" },
];

const SOCIAL_LINKS = [
  {
    label: "LinkedIn",
    href: "https://linkedin.com/company/techindoglobal",
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: "Twitter / X",
    href: "https://twitter.com/techindoglobal",
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: "Facebook",
    href: "https://facebook.com/techindoglobal",
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://instagram.com/techindoglobal",
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "https://youtube.com/@techindoglobal",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    label: "WhatsApp",
    href: `https://wa.me/${CONTACT_INFO.whatsapp}`,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
];

const CONTACT_ROWS = [
  { icon: Mail,           label: CONTACT_INFO.email,         href: `mailto:${CONTACT_INFO.email}` },
  { icon: Phone,          label: CONTACT_INFO.phone,           href: `tel:${CONTACT_INFO.phoneE164}` },
  { icon: MessageCircle,  label: "Chat on WhatsApp",          href: `https://wa.me/${CONTACT_INFO.whatsapp}` },
  { icon: MapPin,         label: CONTACT_INFO.address,        href: null },
];

export default function Footer() {
  const [portalMenuOpen, setPortalMenuOpen] = useState(false);
  const portalMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!portalMenuRef.current?.contains(event.target)) {
        setPortalMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <footer className="relative border-t border-white/[0.06] bg-background">
      <div className="absolute inset-0 gradient-red-subtle opacity-20" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-6">

        {/* Two-column body */}
        <div className="flex flex-col sm:flex-row justify-between gap-10 mb-10">

          {/* Brand + social */}
          <div className="max-w-xs">
            <TechindoLogo size={32} />
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
              {SITE_META.tagline}
            </p>
            <div className="flex flex-wrap gap-2 mt-5">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-8 h-8 rounded-lg glass-card flex items-center justify-center
                             text-muted-foreground hover:text-primary hover:border-primary/30
                             transition-all duration-300"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold font-heading text-foreground mb-3 tracking-wide">
              Contact
            </h4>
            <ul className="space-y-2.5">
              {CONTACT_ROWS.map(({ icon: Icon, label, href }) => (
                <li key={label} className="flex items-start gap-2.5 text-sm text-muted-foreground">
                  <Icon size={14} className="mt-0.5 text-primary shrink-0" />
                  {href ? (
                    <a
                      href={href}
                      target={href.startsWith("http") ? "_blank" : undefined}
                      rel="noopener noreferrer"
                      className="hover:text-primary transition-colors duration-200 leading-snug"
                    >
                      {label}
                    </a>
                  ) : (
                    <span className="leading-snug">{label}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/[0.06] pt-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Techindo Global. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-muted-foreground">
            <Link to="/privacy-policy" className="px-2 py-1 rounded hover:text-primary transition-colors duration-200">
              Privacy Policy
            </Link>
            <span className="text-white/10">|</span>
            <Link to="/terms" className="px-2 py-1 rounded hover:text-primary transition-colors duration-200">
              Terms &amp; Conditions
            </Link>
            <div ref={portalMenuRef} className="relative ml-1">
              {portalMenuOpen && (
                <div className="absolute bottom-full right-0 mb-3 w-56 overflow-hidden rounded-xl border border-white/10 bg-background/95 p-2 text-left shadow-2xl shadow-black/40 backdrop-blur-xl">
                  {TEK_PORTALS.map((portal) => {
                    const itemClass = "flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2.5 text-left transition-colors duration-200 hover:bg-white/[0.06]";
                    const content = (
                      <>
                        <span>
                          <span className="block text-sm font-semibold text-foreground">{portal.label}</span>
                          <span className="block text-[11px] text-muted-foreground">{portal.description}</span>
                        </span>
                        {portal.href ? (
                          <ExternalLink size={14} className="text-primary" />
                        ) : (
                          <span className="rounded-full border border-white/10 px-2 py-0.5 text-[10px] text-muted-foreground">
                            Soon
                          </span>
                        )}
                      </>
                    );

                    return portal.href ? (
                      <a
                        key={portal.label}
                        href={portal.href}
                        className={itemClass}
                        onClick={() => setPortalMenuOpen(false)}
                      >
                        {content}
                      </a>
                    ) : (
                      <button
                        key={portal.label}
                        type="button"
                        className={`${itemClass} cursor-default`}
                        disabled
                      >
                        {content}
                      </button>
                    );
                  })}
                </div>
              )}
              <button
                type="button"
                onClick={() => setPortalMenuOpen((open) => !open)}
                aria-expanded={portalMenuOpen}
                className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 font-semibold text-primary-foreground shadow-lg shadow-primary/20 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-primary/30"
              >
                TEK Portal Login
                <ChevronUp size={14} className={`transition-transform duration-200 ${portalMenuOpen ? "rotate-180" : ""}`} />
              </button>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
